import { ActorSubclass, HttpAgent } from '@icp-sdk/core/agent'
import { _SERVICE as DIP20Actor, idlFactory as dip20Factory } from '../../idls/tokens/dip20.did'
import { _SERVICE as DRC20Actor, idlFactory as drc20Factory } from '../../idls/tokens/drc20.did'
import { _SERVICE as ICPActor, idlFactory as icpFactory } from '../../idls/tokens/icp.did'
import { _SERVICE as ICRC1Actor, idlFactory as icrc1Factory } from '../../idls/tokens/icrc1.did'
import { _SERVICE as ICRC2Actor, idlFactory as icrc2Factory } from '../../idls/tokens/icrc2.did'
import { _SERVICE as ICRC3Actor, idlFactory as icrc3Factory } from '../../idls/tokens/icrc3.did'
import { _SERVICE as XTCActor, idlFactory as xtcFactory } from '../../idls/tokens/xtc.did'
import { createActor } from '../createActor'

interface TokenActor {
  icp?: ActorSubclass<ICPActor>
  icrc1?: ActorSubclass<ICRC1Actor>
  icrc2?: ActorSubclass<ICRC2Actor>
  icrc3?: ActorSubclass<ICRC3Actor>
  dip20?: ActorSubclass<DIP20Actor>
  drc20?: ActorSubclass<DRC20Actor>
  xtc?: ActorSubclass<XTCActor>
}

const getIcrc1Actor = (canisterId: string, agent: HttpAgent) => {
  return createActor<ICRC1Actor>(icrc1Factory, {
    canisterId,
    agent,
  })
}

const getIcrc2Actor = (canisterId: string, agent: HttpAgent) => {
  return createActor<ICRC2Actor>(icrc2Factory, {
    canisterId,
    agent,
  })
}

const getIcrc3Actor = (canisterId: string, agent: HttpAgent) => {
  return createActor<ICRC3Actor>(icrc3Factory, {
    canisterId,
    agent,
  })
}

const getDip20Actor = (canisterId: string, agent: HttpAgent) => {
  return createActor<DIP20Actor>(dip20Factory, {
    canisterId,
    agent,
  })
}

const getDrc20Actor = (canisterId: string, agent: HttpAgent) => {
  return createActor<DRC20Actor>(drc20Factory, {
    canisterId,
    agent,
  })
}

const getIcpActor = (canisterId: string, agent: HttpAgent) => {
  return createActor<ICPActor>(icpFactory, {
    canisterId,
    agent,
  })
}

const getXTCActor = (canisterId: string, agent: HttpAgent) => {
  return createActor<XTCActor>(xtcFactory, {
    canisterId,
    agent,
  })
}

const getTokenActor = (canisterId: string, standard: string, agent: HttpAgent): TokenActor => {
  switch (standard) {
    case 'ICP':
      return { icp: getIcpActor(canisterId, agent) }
    case 'ICRC1':
      return { icrc1: getIcrc1Actor(canisterId, agent) }
    case 'ICRC2':
      return { icrc2: getIcrc2Actor(canisterId, agent) }
    case 'ICRC3':
      return { icrc3: getIcrc3Actor(canisterId, agent) }
    case 'DIP20':
      return { dip20: getDip20Actor(canisterId, agent) }
    case 'DRC20':
      return { drc20: getDrc20Actor(canisterId, agent) }
    case 'XTC':
    case 'DIP20-XTC':
      return { xtc: getXTCActor(canisterId, agent) }
    default:
      return {}
  }
}

export default getTokenActor
